import { render, staticRenderFns } from "./tableFieldProps.vue?vue&type=template&id=efb49ede&scoped=true&"
import script from "./tableFieldProps.vue?vue&type=script&lang=js&"
export * from "./tableFieldProps.vue?vue&type=script&lang=js&"
import style0 from "./tableFieldProps.vue?vue&type=style&index=0&id=efb49ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb49ede",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VDivider,VFlex,VIcon,VLayout,VTextField})
